export const comments_3899724 = {"data":{"data":[],"links":{}}}